import React, { FC, ReactNode, memo } from 'react';
import {
  Modal,
  StyleProp,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from 'react-native';
import { createUseStyles } from 'core/src';

interface MyModalProps {
  handleModalClose?: () => void;
  modalVisible: boolean;
  children: ReactNode;
  classesOut?: StyleProp<ViewStyle>;
  classesIn?: StyleProp<ViewStyle>;
  animationType?: any;
}

const MyModal: FC<MyModalProps> = memo(
  ({
    handleModalClose,
    modalVisible,
    children,
    classesOut,
    classesIn,
    animationType,
  }) => {
    const { styles } = useStyles();
    return (
      <Modal
        animationType={animationType}
        transparent={true}
        visible={modalVisible}
        onRequestClose={handleModalClose}
      >
        <TouchableWithoutFeedback onPress={handleModalClose}>
          <View style={[styles.modalContainer, classesOut]}>
            <TouchableWithoutFeedback>
              <View style={[styles.modalContent, classesIn]}>{children}</View>
            </TouchableWithoutFeedback>
          </View>
        </TouchableWithoutFeedback>
      </Modal>
    );
  },
);

const useStyles = createUseStyles(({ colors, theme }) => ({
  modalContainer: {
    flex: 1,
    justifyContent: 'flex-start',
  },
  modalContent: {
    backgroundColor: colors.container,
    padding: 20,
    borderRadius: 10,
  },
}));

export { MyModal };
